{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) ElwaCon GmbH & Co. KG
    Address:            Lessingstr. 4, 26188 Edewecht, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             m.ellermann@elwacon.de
    HTTP:               elwacon.de

    UnitName:           HBMWebDef
    Folder:
    Created:            Sun 07.05.2023 21:45
    Author:             Michael Ellermann

    ShortDescription:

    Description:

**                                                                                                **
****************************************************************************************************
MnemoREM}

unit HBMWebDef;

interface

uses
  Vcl.Graphics;


const

  cLockIniMessage = 'Der Spielleiter hat das System noch nicht initialisiert, bitte warten Sie bis der Spielleiter die Initialisierung durchgeführt hat';

  cLockModeratorMessage = 'Der Spielleiter hat das Teilnehmer System gesperrt';

  cJWTSecret = 'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY4ODY2NjQzNywiaWF0IjoxNjg4NjY2NDM3fQ.EMUc-VWJcTi75-zr83RE6OxdOhHGdD6C8ahqnTdje-c';

  // Hier umstellen wenn der lokale Rest Server genutzt werden soll
  cXDataServerUrl = 'https://hbm-online.eu/MFCWebServices/';
//  cXDataServerUrl = 'http://localhost/MFCWebServices/';

  cXChatServerUrl = 'hbm-online.eu';
//  cXChatServerUrl = 'localhost';

  cGridHighLight : TColor = clInfoBk;

  cLockCheckInterval : integer = 60000;

  cFloatMaskNoDecimals = '0';

  cFloatMask2Decimals = '0.00';

  cFloatMask1Decimal = '0.0';

  cFloatMask2DecimalsThousandSep = '#,##0.00';

  cFloatMask1DecimalsThousandSep = '#,##0.0';

  cSetOfNumberStrings = ['0'..'9'];

  cReportTemplatePrefix = 'KHSFORM.';

  cKPIPoints : integer = 8;

  cMaxClientCalculationCount : integer = 3;

  cTokenExpirationTime : double = 0.33333;  // bei einem TDateTime entspricht das ca. 8 Stunden

var
  MyToken : String;


implementation


end.

